import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type State = {
  data: any;
  dataConsultantInfo: any;
  idConsultantAndFragment: number | string;
  idConsultantInfo: number | string;
  isShowModalAgree: { isShow: boolean; type: string };
  isShowModalDisAgree: { isShow: boolean; type: string };
  idPhieuKhamTV: string;
};

const initialState: State = {
  data: null,
  idConsultantAndFragment: null,
  idConsultantInfo: null,
  isShowModalAgree: { isShow: false, type: null },
  isShowModalDisAgree: { isShow: false, type: null },
  dataConsultantInfo: null,
  idPhieuKhamTV: null,
};

export const consultantAndFragmentSlice = createSlice({
  name: "consultantAndFragment",
  initialState: initialState,
  reducers: {
    setDataConsultantAndFragment: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        data: actions.payload,
      };
    },
    setDataConsultantInfo: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        dataConsultantInfo: actions.payload,
      };
    },
    setIdConsultantInfo: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        idConsultantInfo: actions.payload,
      };
    },
    setIdConsultantAndFragment: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        idConsultantAndFragment: actions.payload,
      };
    },
    setIdPhieuKhamTV: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idPhieuKhamTV: actions.payload,
      };
    },
    setIsShowModalAgree: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        isShowModalAgree: actions.payload,
      };
    },
    setIsShowModalDisAgree: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        isShowModalDisAgree: actions.payload,
      };
    },
  },
});

export const {
  setDataConsultantAndFragment,
  setIdConsultantAndFragment,
  setIsShowModalAgree,
  setIsShowModalDisAgree,
  setDataConsultantInfo,
  setIdConsultantInfo,
  setIdPhieuKhamTV,
} = consultantAndFragmentSlice.actions;
export default consultantAndFragmentSlice.reducer;
